import React from 'react'
import classes from './CollapseDiv.module.css'
import notes from '../../../../Assests/Image/SVG/notes.png'
import PPT from '../../../../Assests/Image/SVG/PPT.png'
import qp from '../../../../Assests/Image/SVG/questionPaper.png'
import MCQ from '../../../../Assests/Image/SVG/MCQ.png'
const CollapseDiv = (props) => {
    let style = {}, style2 = {}
    if (props.data.length > 4) {
        style = {
            "width": "77.7%"
        }
        style2 = {
            "padding-left": "35px"
        }
    }
    let content = props.data.map((index) => {
        let title = null
        let icon = null
        if (index.content_type === "1") {
            title = "PPT"
            icon = PPT
        }
        else if (index.content_type === "2") {
            title = "MCQ"
            icon = MCQ
        }
        else if (index.content_type === "3") {
            title = "Question Bank"
            icon = qp
        }
        else if (index.content_type === "4") {
            title = "NOTES"
            icon = notes
        }
        else if (index.content_type === "5") {
            title = "Model Solved Question Paper"
            icon = qp
        }
        return (
            <div className={classes.cont}>
                <div className={classes.contentCont}>
                    <div className={classes.content}>
                        <img className={classes.icon} src={icon} alt="img" />
                        <span> <p className={classes.title}>{title}</p></span>
                    </div>
                    <div className={classes.buttonCont}>
                        <button className={classes.btn}>Read</button>
                        <p className={classes.time}>02:00</p>
                    </div>
                </div>
                <hr />
            </div>
        )
    })

    return (

        <div className={classes.container}>
            <div className={classes.heading} style={style}>
                <p className={classes.headingText} style={style2}>Content Listing </p>
                <p className={classes.headingText}> Time </p>
            </div>
            <hr />
            <div className={classes.mainContent}> {content}</div>
        </div>
    )
}
export default CollapseDiv